import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import type { ReactElement } from 'react';
import styled from 'styled-components';

import { NewsList } from './NewsList';
import { SectionTitle } from '@/components/elements/SectionTitle';
import { Spacer } from '@/components/elements/Spacer';
import { TitleLayout } from '@/components/enlayout';
import { Head } from '@/components/enlayouts/Head';

import type { NewsRelease, NewsReleaseTag } from '@/types/newsRelease';

// import { Link } from 'react-scroll'


type ReleasePageProps = {
  newsRelease: NewsRelease[]
  tagList: readonly NewsReleaseTag[]
}

export const ReleasePage = ({ newsRelease, tagList }: ReleasePageProps) => {
  const router = useRouter()
  const tag = router.query.tag
  const initialTag = typeof tag === 'string' ? tag : undefined

  return (
    <Wrapper>
      <SectionTitle
        enTitleText="News Release"
        subTitleText=""
        color="normal"
      />
      <Spacer h={{ sp: 50, pc: 50 }} />
      <HiddenNewsList>
        <NewsList
          newsRelease={newsRelease}
          tagList={tagList}
          initialTag={initialTag}
        />
      </HiddenNewsList>
      {/* 緊急でニュースを追加 */}
      <div style={{ marginTop: '20px' }}>
      <EnNewslist>
        <div>
          <p>2023/12/28</p>
          <Link href="/en/news/ennews">
            <a>Establishment of The English Version of The Website</a>
          </Link>
        </div>
      </EnNewslist>
      </div>
      
    </Wrapper>
  )
}

ReleasePage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'Newsroom',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Newsroom', path: '/en/news/' },
    { name: 'News Release', path: '' },
  ]

  return (
    <>
      <Head
        title="News Release"
        description="The latest information, including press releases, announcements introducing various initiatives, and more."
        ogp={{ url: 'en/news/release/' }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}

const Wrapper = styled.div`
  width: 1045px;
  margin: 0 auto;
  padding: 70px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 80px;
  }
`
const EnNewslist = styled.div`
div {
  display: flex;
  align-items: center;
}

p {
  margin-right: 40px;
  margin-left: 30px
}

a:hover {
  text-decoration: underline;
}
`
const HiddenNewsList = styled.div`
  display: none;
`;
